import { createSlice } from '@reduxjs/toolkit';
import { UserSettingsStateType, UserSettingsType } from 'src/types/userSettings';

const initialState: UserSettingsStateType = {
    data: null,
    loading: false,
    error: false,
};
export const userSettingsSlice = createSlice({
    name: 'userSettings',
    initialState,
    reducers: {
        initUserSettings: (state, action: { type: string; payload: UserSettingsType }) => {
            state.data = action.payload;
        },
        getUserSettingsFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getUserSettingsFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getUserSettingsFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        editUserSettingsFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        editUserSettingsFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        editUserSettingsFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearUserSettings: () => initialState,
    },
});

export const {
    initUserSettings,
    getUserSettingsFetch,
    getUserSettingsFetchSuccess,
    getUserSettingsFetchFailure,
    editUserSettingsFetch,
    editUserSettingsFetchSuccess,
    editUserSettingsFetchFailure,
    clearUserSettings,
} = userSettingsSlice.actions;

export default userSettingsSlice.reducer;
